import {
  Button,
  Flex,
  FlexBox,
  Heading,
  Icon,
  Label,
  Table,
  TableBody,
  TableCell,
  TableHeader,
  TableHeaderCell,
  TableRow,
} from "@braze/beacon-core";
import { RoundedCard } from "../../shared/RoundedCard";
import { useState } from "react";
import { NewParentObject, ParentCampaignObject } from "../../types/APITypes";
import styled from "styled-components";
import { useGlobalAppContext } from "../../contexts/GlobalAppContext";
import { RequiredSelect } from "../../shared/forms/RequiredSelect";
import { formatOption } from "../../util/optionsFormatter";
import { MARKETING_PROGRAMS } from "../../constants/SelectConstants";
import { useCreateNewParentCampaign } from "../../hooks/useCreateNewParentCampaign";
import { RequiredText } from "../../shared/forms/RequiredText";
import { useSetExistingParentActivity } from "../../hooks/useSetExistingParentActivity";

export const ParentCampaignsTable = () => {
  const [newParent, setNewParent] = useState<NewParentObject>({} as NewParentObject);
  const { parentCampaigns, setRefresh } = useGlobalAppContext();

  const [createNewParent, createNewParentResponse] = useCreateNewParentCampaign();
  const [setParentActivity, setParentActivityResponse] = useSetExistingParentActivity();

  const handleFieldChange = (key: keyof NewParentObject) => {
    return (value: string | number) => {
      let newVal;

      if (typeof value === "object" && value != null) {
        if (key === "marketing_program") {
          newVal = { [key]: value["value"], marketing_program_id: MARKETING_PROGRAMS[value["value"]] };
        }
        // else { newVal = {[key] : value["value"]}; }
      } else {
        newVal = { [key]: value };
      }

      setNewParent({ ...newParent, ...newVal });
    };
  };

  return (
    <Flex direction="column">
      <RoundedCard style={{ margin: "0px", marginTop: "3rem" }}>
        <Label
          style={{ display: "flex", alignItems: "center", fontSize: "16px", height: "100%", marginBottom: "1rem" }}
        >
          New Parent Campaign:
        </Label>
        <GroupBox>
          <RequiredText name={"SFDC Campaign ID:"} handleChange={handleFieldChange("campaign_id")} />
          <RequiredSelect
            name={"Marketing Program:"}
            options={formatOption(Object.keys(MARKETING_PROGRAMS), false)}
            handleChange={handleFieldChange("marketing_program")}
          />
        </GroupBox>
        <Button onClick={() => createNewParent(newParent).then((r) => setRefresh(true))}>Add Parent Campaign</Button>
      </RoundedCard>
      <RoundedCard style={{ margin: "0px", marginTop: "3rem" }}>
        <Heading level={2}>Active Parent Campaigns</Heading>
        <Table>
          <TableHeader>
            <TableRow>
              <TableHeaderCell>Deactivate</TableHeaderCell>
              <TableHeaderCell>Parent Campaign Name</TableHeaderCell>
              <TableHeaderCell>Parent Campaign ID</TableHeaderCell>
              <TableHeaderCell>Marketing Program</TableHeaderCell>
              <TableHeaderCell>Fiscal Year</TableHeaderCell>
              <TableHeaderCell>Fiscal Quarter</TableHeaderCell>
            </TableRow>
          </TableHeader>
          <TableBody>
            {parentCampaigns
              ?.filter((p: ParentCampaignObject) => p.is_active === true)
              .map((c) => {
                return (
                  <TableRow>
                    <TableCell>
                      <StyledIcon name={"x"} onClick={() => setParentActivity(c).then((r) => setRefresh(true))} />
                    </TableCell>
                    <TableCell>{c.parent_campaign_name}</TableCell>
                    <TableCell>{c.parent_campaign_id}</TableCell>
                    <TableCell>{c.marketing_program}</TableCell>
                    <TableCell>{c.fiscal_year}</TableCell>
                    <TableCell style={{ borderBottom: "0px" }}>{c.fiscal_quarter}</TableCell>
                  </TableRow>
                );
              })}
          </TableBody>
        </Table>
      </RoundedCard>
      <RoundedCard style={{ margin: "0px", marginTop: "3rem" }}>
        <Heading level={2}>Inactive Parent Campaigns</Heading>
        <Table>
          <TableHeader>
            <TableRow>
              <TableHeaderCell>Activate</TableHeaderCell>
              <TableHeaderCell>Parent Campaign Name</TableHeaderCell>
              <TableHeaderCell>Parent Campaign ID</TableHeaderCell>
              <TableHeaderCell>Fiscal Year</TableHeaderCell>
              <TableHeaderCell>Fiscal Quarter</TableHeaderCell>
            </TableRow>
          </TableHeader>
          <TableBody>
            {parentCampaigns
              .sort((one, two) => {
                if (one.parent_campaign_name > two.parent_campaign_name) {
                  return 1;
                } else {
                  return -1;
                }
              })
              .filter((p: ParentCampaignObject) => p.is_active === false)
              .map((c) => {
                return (
                  <TableRow>
                    <TableCell>
                      <StyledIcon
                        className="but"
                        name={"plus"}
                        onClick={() => setParentActivity(c).then((r) => setRefresh(true))}
                      />
                    </TableCell>
                    <TableCell>{c.parent_campaign_name}</TableCell>
                    <TableCell>{c.parent_campaign_id}</TableCell>
                    <TableCell>{c.fiscal_year}</TableCell>
                    <TableCell style={{ borderBottom: "0px" }}>{c.fiscal_quarter}</TableCell>
                  </TableRow>
                );
              })}
          </TableBody>
        </Table>
      </RoundedCard>
    </Flex>
  );
};

const StyledIcon = styled(Icon)`
  width: 100%;
  .svg-inline--fa {
    border-bottom: 0px !important;
  }
  cursor: pointer;
  border-bottom: 0px !important;
`;
const GroupBox = styled(FlexBox)`
  justify-content: space-between;
  margin-bottom: 1rem;
  > * {
    &:not(:last-of-type) {
      margin-right: 20px;
    }
  }
`;
